import axios from 'axios'
import store from '@/store'
import { apiUrl } from '@/config/config'
import i18n from '@/i18n'

class Auth {

  constructor(version = 'v1') {
    this.http = axios.create({
      baseURL: apiUrl + version + '/',
      headers: {
        'Content-Type': 'application/json'
      }
    })
  }

  requestResetPassword(email, locale = 'de') {
    return new Promise((resolve, reject) => {
      this.http.post('/users/request_password_reset', { email, locale }).then(response => {
        resolve(response)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    })
  }

  resetPassword(token, password, password_confirmation, locale = 'de') {
    return new Promise((resolve, reject) => {
      this.http.post('/users/reset_password', { token, password, password_confirmation, locale }).then(response => {
        resolve(response)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    })
  }

  confirmAccount(token, password, password_confirmation, firstname, lastname, locale = 'de') {
    return new Promise((resolve, reject) => {
      this.http.post('/users/accept_invitation', { token, password, password_confirmation,  firstname, lastname, locale }).then(response => {
        resolve(response)
      }).catch(e => {
        this.handleError(e)
        reject(e)
      })
    })
  }

  auth(email, password, firstname, lastname) {
    if (!this.validateEmail(email)) {
      let message = i18n.t('errors.authentication.wrong_email')
      store.dispatch('addAxiosError', message)
      return new Promise((resolve, reject) => { reject({ response: { data: { errors: [{ code: 'authentication.wrong_email' }] } } }) })
    } else if (!this.validatePassword(password)) {
      let message = i18n.t('errors.authentication.wrong_password')
      store.dispatch('addAxiosError', message)
      return new Promise((resolve, reject) => { reject({ response: { data: { errors: [{ code: 'authentication.wrong_password' }] } } }) })
    } else {
      // If basic validations passed, we send the request
      return new Promise((resolve, reject) => {
        this.http.post('auth', { email, password, firstname, lastname }).then(response => {
          resolve(response)
        }).catch(e => {
          this.handleError(e)
          reject(e)
        })
      })
    }
  }

  // basic format validation
  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  // 1 letter, 1 number & 6 characters
  validatePassword(password) {
    return password.length > 0;
  }

  // sha256 ? md5 ?
  passwordEncryption(password) {
    if(password.length < 8){
      return false 
    }
    let numberRegex = /[0-9]/
    if(!numberRegex.test(password)){
      return false
    }
    let letterRegex = /[a-z]/
    if(!letterRegex.test(password)){
      return false 
    }
    return true
  }

  // Ajax error handling
  handleError(error) {
    if (error.response) {
      // The request was made and the server responded with a status code outside of 2xx
      if (error.response.status === 401) {
        let message = i18n.t('errors.' + error.response.data.errors[0].code)
        store.dispatch('addAxiosError', message)
      } else {
        console.log(error.response)
      }

    } else if (error.request) {
      // The request was made but no response was received
      let message = i18n.t('errors.server_unreachable')
      store.dispatch('addAxiosError', message)
    } else {
      // Something happened in setting up the request that triggered an Error
      // Should not happen
      console.log('Error', error.message);
    }

  }

}

export default Auth


// WEBPACK FOOTER //
// ./src/api/Auth.js